import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Navigation',
    data: function () {
        return {
            menuOpened: false,
            desktop: {
                current: 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium',
                default: 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium',
            },
            mobile: {
                current: 'bg-indigo-50 border-indigo-500 text-indigo-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium',
                default: 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium',
            },
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },

        ...mapGetters({
            promotion: 'promotion/promotion',
        }),
    },

    methods: {
        ...mapActions('user', ['logout']),
    },
}